import { useState, type JSX } from 'react';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import WsModalCreateContent from 'pages/ws/components/modalCreateContent/WsModalCreateContent';

/**
 * コンテンツ画面 0件表示コンポーネント
 */
export default function WsContentSearchEmpty(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);
  const [modalCreateContentOpenState, setModalCreateContentOpenState] = useState(false);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * コンテンツ作成モーダルを開く
   */
  const onModalCreateContentOpen = () => {
    setModalCreateContentOpenState(true);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-header">
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">こんにちは、{acctState.user.name}さん</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="section-contents">
        <div className="container">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3 className="text-lead text-center">新しいコンテンツを作りましょう。</h3>
            <a
              onClick={onModalCreateContentOpen}
              className="btn btn-common btn-common-w238 outline-blue"
            >
              + 新しいコンテンツを作成する
            </a>
          </div>
        </div>
      </section>
      {/* コンテンツ作成モーダル */}
      <WsModalCreateContent
        open={modalCreateContentOpenState}
        setOpen={setModalCreateContentOpenState}
      />
    </>
  );
}
